import { Box, Typography } from "@mui/material";

export default function AgentForm() {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5">Créer ou modifier un agent</Typography>
    </Box>
  );
}
